module.exports = __webpack_public_path__ + "1b6065b44a8f53b2f985c228d271f28c.pdf";